<template>
  <div class="partner-dashboard">
    <div class="page-wrapper">
      <div class="welcome-box">
        <h1>Welcome</h1>
        <p>to Partner Dashboard!</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "PartnerDashboard",
    }
</script>
<style lang="scss" scoped>
        .page-wrapper {
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Arial, sans-serif;
      background-color: #f4f6f8;
    }

    .welcome-box {
      text-align: center;
      padding: 40px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }
</style>
